import React from 'react'
import { Box, TextField, Select, MenuItem, InputAdornment, IconButton } from '@mui/material'
import { Search as SearchIcon, ExpandMore, Close as CloseIcon } from '@mui/icons-material'

const DEFAULT_INPUT_MINWIDTH = 280
const DEFAULT_SELECT_MINWIDTH = 140

/**
 * Переиспользуемая панель поиска: поле ввода + выбор поля поиска (Select).
 * @param {Object} props
 * @param {{ value: string, label: string }[]} props.options - опции для Select (поле поиска)
 * @param {string} props.searchField - выбранное поле
 * @param {function(string): void} props.onSearchFieldChange
 * @param {string} [props.globalFilter] - значение строки поиска
 * @param {function(string|undefined): void} props.onGlobalFilterChange
 * @param {number} [props.inputMinWidth]
 * @param {number} [props.selectMinWidth]
 * @param {string} [props.placeholder='Search…']
 */
export default function TableSearchWithField({
  options,
  searchField,
  onSearchFieldChange,
  globalFilter,
  onGlobalFilterChange,
  inputMinWidth = DEFAULT_INPUT_MINWIDTH,
  selectMinWidth = DEFAULT_SELECT_MINWIDTH,
  placeholder = 'Search…'
}) {
  return (
    <TextField
      size="small"
      fullWidth
      placeholder={placeholder}
      value={globalFilter ?? ''}
      onChange={(e) => onGlobalFilterChange(e.target.value || undefined)}
      sx={{
        minWidth: inputMinWidth,
        '& .MuiOutlinedInput-root': {
          borderRadius: 999,
          pr: 0,
          backgroundColor: '#FCFCFC',
          '& fieldset': { borderColor: '#D9D9D9' },
          '&:hover fieldset': { borderColor: '#BFBFBF' },
          '&.Mui-focused fieldset': { borderColor: '#32355A' },
        }
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" sx={{ mr: 0 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, pl: 0.5 }}>
              <SearchIcon sx={{ color: 'action.active' }} />
              <Select
                size="small"
                value={searchField}
                onChange={(e) => onSearchFieldChange(e.target.value)}
                variant="outlined"
                IconComponent={ExpandMore}
                sx={{
                  minWidth: selectMinWidth,
                  border: 'none',
                  '& fieldset': { border: 'none' },
                  '& .MuiSelect-select': {
                    py: 0.25,
                    pr: 2,
                    pl: 1.5,
                  },
                  fontWeight: 500,
                  borderRadius: 999,
                  backgroundColor: '#E8E8E8'
                }}
                MenuProps={{
                  PaperProps: { sx: { mt: 1.5, borderRadius: 2, boxShadow: 2 } }
                }}
              >
                {options.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </InputAdornment>
        ),
        endAdornment: globalFilter ? (
          <InputAdornment position="end" sx={{ ml: 0, mr: 1 }}>
            <IconButton
              size="small"
              edge="end"
              onClick={() => onGlobalFilterChange(undefined)}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : null
      }}
    />
  )
}

export { DEFAULT_INPUT_MINWIDTH, DEFAULT_SELECT_MINWIDTH }
